export default "__VITE_ASSET__Dzg$UPue__"